import { useEffect } from "react";

export function useEditableEffects({
	isEditing,
	menuIsOpen,
	value,
	options,
	containerRef,
	selectRef,
	isMountedRef,
	abortRef,
	setIsEditing,
	setSelectedValue,
	setErrorText,
	setDynamicOptions,
	valueToSelectValue,
}) {
	useEffect(() => {
		isMountedRef.current = true;
		return () => {
			isMountedRef.current = false;
			if (abortRef.current) {
				try {
					// eslint-disable-next-line react-hooks/exhaustive-deps
					abortRef.current.abort();
				} catch {
					// Ignore abort errors
				}
			}
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (!isEditing) {
			setDynamicOptions(options);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [options, isEditing]);

	useEffect(() => {
		if (!isEditing) return;

		const handleClickOutside = (event) => {
			if (menuIsOpen) {
				return;
			}

			if (containerRef.current?.contains(event.target)) {
				return;
			}

			setSelectedValue(valueToSelectValue(value));
			setErrorText("");
			setIsEditing(false);
		};

		document.addEventListener("mousedown", handleClickOutside, true);

		return () => {
			document.removeEventListener("mousedown", handleClickOutside, true);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isEditing, menuIsOpen]);

	useEffect(() => {
		if (!isEditing) {
			setSelectedValue(valueToSelectValue(value));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [value, isEditing]);

	useEffect(() => {
		if (isEditing && selectRef.current) {
			selectRef.current.focus();
		}
	}, [isEditing, selectRef]);
}
